export var TransactionFlow;
(function (TransactionFlow) {
    TransactionFlow[TransactionFlow["CASH_IN"] = 1] = "CASH_IN";
    TransactionFlow[TransactionFlow["CASH_OUT"] = 2] = "CASH_OUT";
    TransactionFlow[TransactionFlow["REVERSAL_IN"] = 3] = "REVERSAL_IN";
    TransactionFlow[TransactionFlow["REVERSAL_OUT"] = 4] = "REVERSAL_OUT";
    TransactionFlow[TransactionFlow["SCHEDULED"] = 5] = "SCHEDULED";
})(TransactionFlow || (TransactionFlow = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["CONTACT"] = 0] = "CONTACT";
    TransactionType[TransactionType["P2P"] = 1] = "P2P";
    TransactionType[TransactionType["TED"] = 2] = "TED";
    TransactionType[TransactionType["BILLET"] = 3] = "BILLET";
    TransactionType[TransactionType["RECHARGE_BILLET"] = 4] = "RECHARGE_BILLET";
    TransactionType[TransactionType["DEPOSIT"] = 5] = "DEPOSIT";
    TransactionType[TransactionType["PIX"] = 6] = "PIX";
    TransactionType[TransactionType["RECHARGE_CELLPHONE"] = 8] = "RECHARGE_CELLPHONE";
    TransactionType[TransactionType["TARIFF"] = 9] = "TARIFF";
    TransactionType[TransactionType["ATM_WITHDRAW"] = 10] = "ATM_WITHDRAW";
    TransactionType[TransactionType["ATM_DEPOSIT"] = 11] = "ATM_DEPOSIT";
    TransactionType[TransactionType["CREDIT"] = 12] = "CREDIT";
    TransactionType[TransactionType["DEBIT"] = 13] = "DEBIT";
    TransactionType[TransactionType["BALANCE_BLOCK"] = 15] = "BALANCE_BLOCK";
    TransactionType[TransactionType["BALANCE_UNLOCK"] = 16] = "BALANCE_UNLOCK";
    TransactionType[TransactionType["PIX_REFUND"] = 17] = "PIX_REFUND";
    TransactionType[TransactionType["BALANCE"] = 21] = "BALANCE";
    TransactionType[TransactionType["TOTAL_AMOUNT"] = 22] = "TOTAL_AMOUNT";
    TransactionType[TransactionType["PIX_WITHDRAW"] = 23] = "PIX_WITHDRAW";
    TransactionType[TransactionType["PIX_CHANGE"] = 24] = "PIX_CHANGE";
    TransactionType[TransactionType["CARD_DEBIT"] = 14] = "CARD_DEBIT";
    TransactionType[TransactionType["PURCHASE_ORDER"] = 18] = "PURCHASE_ORDER";
    TransactionType[TransactionType["POINTS"] = 19] = "POINTS";
    TransactionType[TransactionType["INVESTMENT_APPLICATION"] = 20] = "INVESTMENT_APPLICATION";
    TransactionType[TransactionType["QR_CODE"] = 25] = "QR_CODE";
    TransactionType[TransactionType["CARD_RECEIVABLE"] = 26] = "CARD_RECEIVABLE";
    TransactionType[TransactionType["UNKNOWN"] = 100] = "UNKNOWN";
})(TransactionType || (TransactionType = {}));
export var TransactionTypeFlow;
(function (TransactionTypeFlow) {
    TransactionTypeFlow["RECHARGE"] = "RECHARGE";
    TransactionTypeFlow["TRANSFER_SENT"] = "TRANSFER_SENT";
    TransactionTypeFlow["TRANSFER_RECEIVED"] = "TRANSFER_RECEIVED";
    TransactionTypeFlow["TRANSFER_REVERSAL"] = "TRANSFER_REVERSAL";
    TransactionTypeFlow["PIX_SENT"] = "PIX_SENT";
    TransactionTypeFlow["PIX_RECEIVED"] = "PIX_RECEIVED";
    TransactionTypeFlow["PIX_REVERSAL_IN"] = "PIX_REVERSAL_IN";
    TransactionTypeFlow["PIX_REVERSAL_OUT"] = "PIX_REVERSAL_OUT";
    TransactionTypeFlow["PIX_SCHEDULED"] = "PIX_SCHEDULED";
    TransactionTypeFlow["BILLET_PAID"] = "BILLET_PAID";
    TransactionTypeFlow["BILLET_RECEIVED"] = "BILLET_RECEIVED";
    TransactionTypeFlow["BILLET_REVERSAL"] = "BILLET_REVERSAL";
    TransactionTypeFlow["BILLET_SCHEDULED"] = "BILLET_SCHEDULED";
    TransactionTypeFlow["P2P_SENT"] = "P2P_SENT";
    TransactionTypeFlow["P2P_RECEIVED"] = "P2P_RECEIVED";
    TransactionTypeFlow["P2P_REVERSAL"] = "P2P_REVERSAL";
    TransactionTypeFlow["BALANCE_BLOCK"] = "BALANCE_BLOCK";
    TransactionTypeFlow["BALANCE_UNLOCK"] = "BALANCE_UNLOCK";
    TransactionTypeFlow["CARD_RECEIVABLE"] = "CARD_RECEIVABLE";
    TransactionTypeFlow["ANOTHER"] = "ANOTHER";
})(TransactionTypeFlow || (TransactionTypeFlow = {}));
export var PixStatus;
(function (PixStatus) {
    PixStatus[PixStatus["ACTIVE"] = 2] = "ACTIVE";
    PixStatus[PixStatus["CLEARING_REGISTRATION_PENDING"] = 1] = "CLEARING_REGISTRATION_PENDING";
    PixStatus[PixStatus["PENDING_PORTABILITY_DICT"] = 3] = "PENDING_PORTABILITY_DICT";
    PixStatus[PixStatus["AWAITING_RETURN_PSP_DONOR"] = 4] = "AWAITING_RETURN_PSP_DONOR";
    PixStatus[PixStatus["PENDING_PORTABILITY_CONFIRMATION"] = 5] = "PENDING_PORTABILITY_CONFIRMATION";
    PixStatus[PixStatus["USER_CONFIRMATION_PENDING_PORTABILITY"] = 6] = "USER_CONFIRMATION_PENDING_PORTABILITY";
    PixStatus[PixStatus["IDENTITY_VALIDATION_PENDING"] = 7] = "IDENTITY_VALIDATION_PENDING";
    PixStatus[PixStatus["PENDING_CLAIM_CONFIRMATION"] = 8] = "PENDING_CLAIM_CONFIRMATION";
    PixStatus[PixStatus["USER_KEY_OWNERSHIP_VALIDATION_PENDING"] = 9] = "USER_KEY_OWNERSHIP_VALIDATION_PENDING";
    PixStatus[PixStatus["CLAIM_AWAITING_RETURN_PSP_DONOR"] = 10] = "CLAIM_AWAITING_RETURN_PSP_DONOR";
    PixStatus[PixStatus["PENDING_VALIDATION_COMPLETE_CLAIM"] = 11] = "PENDING_VALIDATION_COMPLETE_CLAIM";
    PixStatus[PixStatus["EXCLUDED"] = 12] = "EXCLUDED";
    PixStatus[PixStatus["EXPIRED"] = 13] = "EXPIRED";
    PixStatus[PixStatus["PORTABILITY_REQUESTED"] = 14] = "PORTABILITY_REQUESTED";
    PixStatus[PixStatus["DONATED_BY_CLAIM"] = 15] = "DONATED_BY_CLAIM";
    PixStatus[PixStatus["UNSUCCESSFUL_PORTABILITY"] = 16] = "UNSUCCESSFUL_PORTABILITY";
    PixStatus[PixStatus["SUCCESSFUL_PORTABILITY"] = 17] = "SUCCESSFUL_PORTABILITY";
    PixStatus[PixStatus["SUCCESSFUL_CLAIM"] = 18] = "SUCCESSFUL_CLAIM";
    PixStatus[PixStatus["UNSUCCESSFUL_CLAIM"] = 19] = "UNSUCCESSFUL_CLAIM";
    PixStatus[PixStatus["EXCLUSION_PENDING"] = 20] = "EXCLUSION_PENDING";
})(PixStatus || (PixStatus = {}));
export var PixKeyType;
(function (PixKeyType) {
    PixKeyType[PixKeyType["CPF"] = 1] = "CPF";
    PixKeyType[PixKeyType["CNPJ"] = 2] = "CNPJ";
    PixKeyType[PixKeyType["EMAIL"] = 3] = "EMAIL";
    PixKeyType[PixKeyType["PHONE"] = 4] = "PHONE";
    PixKeyType[PixKeyType["RANDOM"] = 5] = "RANDOM";
    PixKeyType[PixKeyType["QRCODE"] = 6] = "QRCODE";
    PixKeyType[PixKeyType["BANK_ACCOUNT"] = 7] = "BANK_ACCOUNT";
})(PixKeyType || (PixKeyType = {}));
export var PixType;
(function (PixType) {
    PixType[PixType["TAX_IDENTIFIER"] = 1] = "TAX_IDENTIFIER";
    PixType[PixType["EMAIL"] = 2] = "EMAIL";
    PixType[PixType["PHONE"] = 3] = "PHONE";
    PixType[PixType["RANDOM"] = 4] = "RANDOM";
    PixType[PixType["AGENCY"] = 5] = "AGENCY";
    PixType[PixType["PORTABILITY"] = 6] = "PORTABILITY";
    PixType[PixType["QR_CODE"] = 7] = "QR_CODE";
})(PixType || (PixType = {}));
export var PixKeyTypeDescription;
(function (PixKeyTypeDescription) {
    PixKeyTypeDescription["QR_CODE"] = "QR_CODE";
    PixKeyTypeDescription["EMAIL"] = "EMAIL";
    PixKeyTypeDescription["CPF"] = "CPF";
    PixKeyTypeDescription["CNPJ"] = "CNPJ";
    PixKeyTypeDescription["PHONE"] = "PHONE";
    PixKeyTypeDescription["RANDOM"] = "RANDOM";
    PixKeyTypeDescription["AGENCY"] = "AGENCY";
    PixKeyTypeDescription["PORTABILITY"] = "PORTABILITY";
})(PixKeyTypeDescription || (PixKeyTypeDescription = {}));
export var PixKeyTypeV3Api;
(function (PixKeyTypeV3Api) {
    PixKeyTypeV3Api["EVP"] = "EVP";
    PixKeyTypeV3Api["RANDOM"] = "RANDOM";
    PixKeyTypeV3Api["EMAIL"] = "EMAIL";
    PixKeyTypeV3Api["PHONE"] = "PHONE";
    PixKeyTypeV3Api["CPF"] = "CPF";
    PixKeyTypeV3Api["CNPJ"] = "CNPJ";
    PixKeyTypeV3Api["AGENCY"] = "AGENCY";
    PixKeyTypeV3Api["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    PixKeyTypeV3Api["QR_CODE"] = "QR_CODE";
    PixKeyTypeV3Api["QRCODE"] = "QRCODE";
})(PixKeyTypeV3Api || (PixKeyTypeV3Api = {}));
export var ChosenType;
(function (ChosenType) {
    ChosenType["COPY"] = "copy";
    ChosenType["REMOVE"] = "remove";
})(ChosenType || (ChosenType = {}));
export var VariantType;
(function (VariantType) {
    VariantType["SUCCESS"] = "success";
    VariantType["ERROR"] = "error";
})(VariantType || (VariantType = {}));
export var ScheduledTransactionType;
(function (ScheduledTransactionType) {
    ScheduledTransactionType["BANK_SLIP"] = "BANKSLIP";
    ScheduledTransactionType["PIX"] = "PIX";
})(ScheduledTransactionType || (ScheduledTransactionType = {}));
export var ExtractType;
(function (ExtractType) {
    ExtractType["PAST"] = "PAST";
    ExtractType["SCHEDULED"] = "SCHEDULED";
})(ExtractType || (ExtractType = {}));
export var ApiErrors;
(function (ApiErrors) {
    ApiErrors["BILLET_ALREADY_PAID"] = "BILLET_ALREADY_PAID";
    ApiErrors["BILLET_EXPIRED"] = "BILLET_EXPIRED";
    ApiErrors["CAN_NOT_FIND_BILLET"] = "CAN_NOT_FIND_BILLET";
    ApiErrors["BILLET_GENERIC"] = "BILLET_GENERIC";
    ApiErrors["ERROR_BILLET_EXPIRED"] = "PAY1201106";
    ApiErrors["ERROR_CAN_NOT_PAY_BILLET_EXPIRED"] = "PAY1201107";
    ApiErrors["ERROR_BILLET_ALREADY_PAID"] = "PAY1201102";
    ApiErrors["ERROR_CAN_NOT_PAY_BILLET_AGAIN"] = "PAY1201108";
    ApiErrors["CAN_NOT_PAY_BILLET"] = "CAN_NOT_PAY_BILLET";
    ApiErrors["PIN_FAILURE_TO_VALIDATE"] = "PIN_FAILURE_TO_VALIDATE";
    ApiErrors["PIX_KEY_VALIDATE_NOT_FOUND"] = "PIX_KEY_NOT_FOUND";
    ApiErrors["NO_FUNDS_AVAILABLE"] = "NO_FUNDS_AVAILABLE";
    ApiErrors["ERROR_NO_FUNDS_AVAILABLE"] = "PAY1201101";
    ApiErrors["CAN_NOT_SCHEDULE_PIX"] = "CAN_NOT_SCHEDULE_PIX";
    ApiErrors["CAN_NOT_TRANSFER_PIX"] = "CAN_NOT_TRANSFER_PIX";
    ApiErrors["CAN_NOT_SCHEDULE_BANK_SLIP"] = "CAN_NOT_SCHEDULE_BANK_SLIP";
    ApiErrors["CAN_NOT_SCHEDULE_INVALID_DAY"] = "PAY1201111";
    ApiErrors["SCHEDULE_ALREADY_EXISTS"] = "PAY1201112";
    ApiErrors["INVALID_PIX_KEY_CREATION_CODE"] = "INVALID_PIX_KEY_CREATION_CODE";
    ApiErrors["PIX_KEY_NOT_FOUND"] = "BIL20011051";
    ApiErrors["TIMEOUT_ERROR"] = "TIMEOUT_ERROR";
    ApiErrors["PARTNER_INTEGRATION_ERROR"] = "PARTNER_INTEGRATION_ERROR";
    ApiErrors["INSTRUCTION_NOT_PENDING"] = "INSTRUCTION_NOT_PENDING";
    ApiErrors["PIX_LIMIT_EXCEEDED"] = "PAY1201417";
    ApiErrors["PAYMENT_ALREADY_EXISTS"] = "PAY1201002";
    ApiErrors["CAN_NOT_VALIDATE_PIX_KEYS"] = "CAN_NOT_VALIDATE_PIX_KEYS";
})(ApiErrors || (ApiErrors = {}));
export var Currency;
(function (Currency) {
    Currency["BRL"] = "BRL";
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
})(Currency || (Currency = {}));
export var TransactionSource;
(function (TransactionSource) {
    TransactionSource["FINTECH_IBK"] = "FINTECH:IBK";
    TransactionSource["PARTNER_PISMO"] = "PARTNER:PISMO";
})(TransactionSource || (TransactionSource = {}));
export var FileType;
(function (FileType) {
    FileType["PDF"] = "pdf";
    FileType["OFX"] = "ofx";
})(FileType || (FileType = {}));
export var AccountTypeAcronym;
(function (AccountTypeAcronym) {
    AccountTypeAcronym["NOT_INFORMED"] = "NOTI";
    AccountTypeAcronym["SAVING_ACCOUNT"] = "SVGS";
    AccountTypeAcronym["PAYMENT_ACCOUNT"] = "SLRY";
    AccountTypeAcronym["CHECKING_ACCOUNT"] = "CACC";
})(AccountTypeAcronym || (AccountTypeAcronym = {}));
export var DocumentTypeNumber;
(function (DocumentTypeNumber) {
    DocumentTypeNumber[DocumentTypeNumber["CPF"] = 1] = "CPF";
    DocumentTypeNumber[DocumentTypeNumber["CNPJ"] = 2] = "CNPJ";
})(DocumentTypeNumber || (DocumentTypeNumber = {}));
export var FavoredContactDetailsType;
(function (FavoredContactDetailsType) {
    FavoredContactDetailsType[FavoredContactDetailsType["PIX_KEY"] = 1] = "PIX_KEY";
    FavoredContactDetailsType[FavoredContactDetailsType["BANK_ACCOUNT"] = 2] = "BANK_ACCOUNT";
})(FavoredContactDetailsType || (FavoredContactDetailsType = {}));
export var QrCodeType;
(function (QrCodeType) {
    QrCodeType["STATIC"] = "STATIC";
    QrCodeType["STATIC_WITHDRAW"] = "STATIC_WITHDRAW";
    QrCodeType["DYNAMIC"] = "DYNAMIC";
    QrCodeType["DYNAMIC_COB"] = "DYNAMIC_COB";
    QrCodeType["DYNAMIC_COBV"] = "DYNAMIC_COBV";
    QrCodeType["DYNAMIC_CHANGE"] = "DYNAMIC_CHANGE";
    QrCodeType["DYNAMIC_WITHDRAW"] = "DYNAMIC_WITHDRAW";
    QrCodeType["IMMEDIATE"] = "IMMEDIATE";
    QrCodeType["DUEDATE"] = "DUEDATE";
})(QrCodeType || (QrCodeType = {}));
export var DocumentTypeDescription;
(function (DocumentTypeDescription) {
    DocumentTypeDescription["CPF"] = "CPF";
    DocumentTypeDescription["CNPJ"] = "CNPJ";
})(DocumentTypeDescription || (DocumentTypeDescription = {}));
export var TransactionModeType;
(function (TransactionModeType) {
    TransactionModeType["MONEY_TRANSFER"] = "MONEY_TRANSFER";
    TransactionModeType["STANDING"] = "STANDING";
    TransactionModeType["PAYMENT"] = "PAYMENT";
})(TransactionModeType || (TransactionModeType = {}));
export var TransactionOperationType;
(function (TransactionOperationType) {
    TransactionOperationType["PIX"] = "PIX";
    TransactionOperationType["BANKSLIP"] = "BANKSLIP";
    TransactionOperationType["TED"] = "TED";
    TransactionOperationType["P2P"] = "P2P";
})(TransactionOperationType || (TransactionOperationType = {}));
export var Flow;
(function (Flow) {
    Flow["IN"] = "IN";
    Flow["OUT"] = "OUT";
})(Flow || (Flow = {}));
export var AccountTypeDescription;
(function (AccountTypeDescription) {
    AccountTypeDescription["CURRENT"] = "CURRENT";
    AccountTypeDescription["SAVINGS"] = "SAVINGS";
    AccountTypeDescription["PAYMENTS"] = "PAYMENTS";
    AccountTypeDescription["IP"] = "IP";
})(AccountTypeDescription || (AccountTypeDescription = {}));
export var AccountType;
(function (AccountType) {
    AccountType[AccountType["CURRENT"] = 1] = "CURRENT";
    AccountType[AccountType["SAVINGS"] = 2] = "SAVINGS";
    AccountType[AccountType["PAYMENTS"] = 3] = "PAYMENTS";
    AccountType[AccountType["IP"] = 4] = "IP";
})(AccountType || (AccountType = {}));
export var BillType;
(function (BillType) {
    BillType[BillType["PIX"] = 1] = "PIX";
    BillType[BillType["BARCODE"] = 2] = "BARCODE";
    BillType[BillType["ACCOUNT"] = 3] = "ACCOUNT";
})(BillType || (BillType = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["CPF"] = 1] = "CPF";
    DocumentType[DocumentType["CNH"] = 2] = "CNH";
    DocumentType[DocumentType["RG"] = 3] = "RG";
    DocumentType[DocumentType["OTHER"] = 4] = "OTHER";
})(DocumentType || (DocumentType = {}));
export var OperationCode;
(function (OperationCode) {
    OperationCode[OperationCode["TR_FEES"] = 0] = "TR_FEES";
    OperationCode[OperationCode["BANKSLIP"] = 1] = "BANKSLIP";
    OperationCode[OperationCode["TAX"] = 2] = "TAX";
    OperationCode[OperationCode["UTILITIES"] = 3] = "UTILITIES";
    OperationCode[OperationCode["INVOICE"] = 4] = "INVOICE";
    OperationCode[OperationCode["PAYROLL"] = 5] = "PAYROLL";
    OperationCode[OperationCode["EMPLOYEE_VACATION"] = 6] = "EMPLOYEE_VACATION";
    OperationCode[OperationCode["EMPLOYEE_TERMINATION_FEES"] = 7] = "EMPLOYEE_TERMINATION_FEES";
    OperationCode[OperationCode["EMPLOYEE_13TH_SALARY"] = 8] = "EMPLOYEE_13TH_SALARY";
    OperationCode[OperationCode["EMPLOYEE_OTHER_PAYMENTS"] = 9] = "EMPLOYEE_OTHER_PAYMENTS";
})(OperationCode || (OperationCode = {}));
export var BankName;
(function (BankName) {
    BankName["CELCOIN"] = "CELCOIN IP S.A.";
})(BankName || (BankName = {}));
export var BillingTermVersionStatusType;
(function (BillingTermVersionStatusType) {
    BillingTermVersionStatusType["CREATED"] = "CREATED";
    BillingTermVersionStatusType["ACTIVATED"] = "ACTIVATED";
    BillingTermVersionStatusType["ACCEPTED"] = "ACCEPTED";
    BillingTermVersionStatusType["PENDING"] = "PENDING";
    BillingTermVersionStatusType["REJECTED"] = "REJECTED";
    BillingTermVersionStatusType["REVOKED"] = "REVOKED";
})(BillingTermVersionStatusType || (BillingTermVersionStatusType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["APPROVED"] = "APPROVED";
    PaymentStatus["REPROVED"] = "REPROVED";
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["CANCELED"] = "CANCELED";
})(PaymentStatus || (PaymentStatus = {}));
export var FinancialInstructionOperationType;
(function (FinancialInstructionOperationType) {
    FinancialInstructionOperationType["PIX"] = "PIX";
})(FinancialInstructionOperationType || (FinancialInstructionOperationType = {}));
export var AccountsPayableHistoryEvent;
(function (AccountsPayableHistoryEvent) {
    AccountsPayableHistoryEvent[AccountsPayableHistoryEvent["CREATE"] = 1] = "CREATE";
    AccountsPayableHistoryEvent[AccountsPayableHistoryEvent["APPROVED"] = 2] = "APPROVED";
    AccountsPayableHistoryEvent[AccountsPayableHistoryEvent["CANCELLED"] = 3] = "CANCELLED";
    AccountsPayableHistoryEvent[AccountsPayableHistoryEvent["SCHEDULED"] = 4] = "SCHEDULED";
    AccountsPayableHistoryEvent[AccountsPayableHistoryEvent["SCHEDULE_CANCELLED"] = 5] = "SCHEDULE_CANCELLED";
    AccountsPayableHistoryEvent[AccountsPayableHistoryEvent["PROCESSING"] = 6] = "PROCESSING";
    AccountsPayableHistoryEvent[AccountsPayableHistoryEvent["REVIEW_REQUIRED"] = 7] = "REVIEW_REQUIRED";
    AccountsPayableHistoryEvent[AccountsPayableHistoryEvent["AWAITING_APPROVAL"] = 8] = "AWAITING_APPROVAL";
})(AccountsPayableHistoryEvent || (AccountsPayableHistoryEvent = {}));
export const InstructionCurrency = Currency;
export const FinancialInstructionSource = TransactionSource;
export const TransactionsServiceKeyType = PixKeyTypeDescription;
export const TransactionsServiceDocumentType = DocumentTypeDescription;
export const TransactionsServiceQrCodeType = QrCodeType;
